export default __webpack_public_path__ + "static/media/AniruddhaSharma.d59f2f37.png";